import qs from "qs";
import { IAuthError } from "src/contexts/AuthContext/types";

export const getAuthUserCodeFromUrl = (): {
  userCode?: string;
  error?: IAuthError;
} => {
  const urlParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const userCode = urlParams?.["code"] as string;
  const error = urlParams?.["error"] as string;
  const errorDescription = urlParams?.["error_description"] as string;

  return {
    userCode,
    ...(error
      ? {
          error: {
            code: error,
            description: errorDescription,
          },
        }
      : {}),
  };
};
